export const FETCH_DASHBOARD_COUNT_REQUEST = "FETCH_DASHBOARD_COUNT_REQUEST";
export const FETCH_DASHBOARD_COUNT_SUCCESS = "FETCH_DASHBOARD_COUNT_SUCCESS";

export const FETCH_DASHBOARD_SUMMARY_REQUEST =
  "FETCH_DASHBOARD_SUMMARY_REQUEST";
export const FETCH_DASHBOARD_SUMMARY_SUCCESS =
  "FETCH_DASHBOARD_SUMMARY_SUCCESS";

export const FETCH_PATIENT_DETAILS_REQUEST = "FETCH_PATIENT_DETAILS_REQUEST";
export const FETCH_PATIENT_DETAILS_SUCCESS = "FETCH_PATIENT_DETAILS_SUCCESS";

export const FETCH_RECOMMENDED_DOCTORS_REQUEST =
  "FETCH_RECOMMENDED_DOCTORS_REQUEST";
export const FETCH_RECOMMENDED_DOCTORS_SUCCESS =
  "FETCH_RECOMMENDED_DOCTORS_SUCCESS";

export const FETCH_PASSPORT_DETAILS_REQUEST = "FETCH_PASSPORT_DETAILS_REQUEST";
export const FETCH_PASSPORT_DETAILS_SUCCESS = "FETCH_PASSPORT_DETAILS_SUCCESS";

export const PROVIDE_OPINION_REQUEST = "PROVIDE_OPINION_REQUEST";
export const PROVIDE_OPINION_SUCCESS = "PROVIDE_OPINION_SUCCESS";

export const AIRPORT_PICKUP_DETAILS_REQUEST = "AIRPORT_PICKUP_DETAILS_REQUEST";
export const AIRPORT_PICKUP_DETAILS_SUCCESS = "AIRPORT_PICKUP_DETAILS_SUCCESS";

export const DOCTOR_PROVIDED_OPINION_REQUEST =
  "DOCTOR_PROVIDED_OPINION_REQUEST";
export const DOCTOR_PROVIDED_OPINION_SUCCESS =
  "DOCTOR_PROVIDED_OPINION_SUCCESS";

export const FETCH_TEMPLATE_DATA_FIELDS_REQUEST =
  "FETCH_TEMPLATE_DATA_FIELDS_REQUEST";
export const FETCH_TEMPLATE_DATA_FIELDS_SUCCESS =
  "FETCH_TEMPLATE_DATA_FIELDS_SUCCESS";

export const FETCH_GENERATE_TEMPLATE_REQUEST =
  "FETCH_GENERATE_TEMPLATE_REQUEST";
export const FETCH_GENERATE_TEMPLATE_SUCCESS =
  "FETCH_GENERATE_TEMPLATE_SUCCESS";

export const FETCH_EMBASSY_MASTER_REQUEST = "FETCH_EMBASSY_MASTER_REQUEST";
export const FETCH_EMBASSY_MASTER_SUCCESS = "FETCH_EMBASSY_MASTER_SUCCESS";

export const FETCH_VIL_TEMPLATE_REQUEST = "FETCH_VIL_TEMPLATE_REQUEST";
export const FETCH_VIL_TEMPLATE_SUCCESS = "FETCH_VIL_TEMPLATE_SUCCESS";

export const FETCH_VIL_UPDATE_REQUEST = "FETCH_VIL_UPDATE_REQUEST";
export const FETCH_VIL_UPDATE_SUCCESS = "FETCH_VIL_UPDATE_SUCCESS";

export const FETCH_COUNTRY_MASTER_REQUEST = "FETCH_COUNTRY_MASTER_REQUEST";
export const FETCH_COUNTRY_MASTER_SUCCESS = "FETCH_COUNTRY_MASTER_SUCCESS";

export const FETCH_HEALTHCONCERN_REQUEST = "FETCH_HEALTHCONCERN_REQUEST";
export const FETCH_HEALTHCONCERN_SUCCESS = "FETCH_HEALTHCONCERN_SUCCESS";

export const FETCH_HOSPITALS_REQUEST = "FETCH_HOSPITALS_REQUEST";
export const FETCH_HOSPITALS_SUCCESS = "FETCH_HOSPITALS_SUCCESS";

export const FETCH_EXISTING_PATIENTS_REQUEST =
  "FETCH_EXISTING_PATIENTS_REQUEST";
export const FETCH_EXISTING_PATIENTS_SUCCESS =
  "FETCH_EXISTING_PATIENTS_SUCCESS";

export const FETCH_DOCTOR_REMINDER_REQUEST = "FETCH_DOCTOR_REMINDER_REQUEST";
export const FETCH_DOCTOR_REMINDER_SUCCESS = "FETCH_DOCTOR_REMINDER_SUCCESS";

export const RESET_DOCTOR_REMINDER = "RESET_DOCTOR_REMINDER";

export const fetchDashboardCountRequest = (payload) => {
  return {
    type: FETCH_DASHBOARD_COUNT_REQUEST,
    payload,
  };
};

export const fetchDashboardCountSuccess = (payload) => {
  return {
    type: FETCH_DASHBOARD_COUNT_SUCCESS,
    payload,
  };
};

export const fetchDashboardSummaryRequest = (payload) => {
  return {
    type: FETCH_DASHBOARD_SUMMARY_REQUEST,
    payload,
  };
};

export const fetchDashboardSummarySuccess = (payload) => {
  return {
    type: FETCH_DASHBOARD_SUMMARY_SUCCESS,
    payload,
  };
};

export const fetchPatientDetailsRequest = (payload) => {
  return {
    type: FETCH_PATIENT_DETAILS_REQUEST,
    payload,
  };
};

export const fetchPatientDetailsSuccess = (payload) => {
  return {
    type: FETCH_PATIENT_DETAILS_SUCCESS,
    payload,
  };
};

export const fetchRecommendedDoctorsRequest = (payload) => {
  return {
    type: FETCH_RECOMMENDED_DOCTORS_REQUEST,
    payload,
  };
};

export const fetchRecommendedDoctorsSuccess = (payload) => {
  return {
    type: FETCH_RECOMMENDED_DOCTORS_SUCCESS,
    payload,
  };
};

export const fetchPassportDetailsRequest = (payload, passportLabel) => {
  return {
    type: FETCH_PASSPORT_DETAILS_REQUEST,
    payload,
    passportLabel,
  };
};

export const fetchPassportDetailsSuccess = (payload, passportLabel) => {
  return {
    type: FETCH_PASSPORT_DETAILS_SUCCESS,
    payload,
    passportLabel,
  };
};

export const fetchProvideOpinionRequest = (payload) => {
  return {
    type: PROVIDE_OPINION_REQUEST,
    payload,
  };
};

export const fetchProvideOpinionSuccess = (payload) => {
  return {
    type: PROVIDE_OPINION_SUCCESS,
    payload,
  };
};

export const fetchAirportPickUpRequest = (payload) => {
  return {
    type: AIRPORT_PICKUP_DETAILS_REQUEST,
    payload,
  };
};

export const fetchAirportPickUpSuccess = (payload) => {
  return {
    type: AIRPORT_PICKUP_DETAILS_SUCCESS,
    payload,
  };
};

export const fetchDoctorProvidedOpinionRequest = (payload) => {
  return {
    type: DOCTOR_PROVIDED_OPINION_REQUEST,
    payload,
  };
};

export const fetchDoctorProvidedOpinionSuccess = (payload) => {
  return {
    type: DOCTOR_PROVIDED_OPINION_SUCCESS,
    payload,
  };
};

export const fetchTemplateDataFieldsRequest = (payload) => {
  return {
    type: FETCH_TEMPLATE_DATA_FIELDS_REQUEST,
    payload,
  };
};

export const fetchTemplateDataFieldsSuccess = (payload) => {
  return {
    type: FETCH_TEMPLATE_DATA_FIELDS_SUCCESS,
    payload,
  };
};

export const fetchGenerateTemplateRequest = (payload) => {
  return {
    type: FETCH_GENERATE_TEMPLATE_REQUEST,
    payload,
  };
};

export const fetchGenerateTemplateSuccess = (payload) => {
  return {
    type: FETCH_GENERATE_TEMPLATE_SUCCESS,
    payload,
  };
};

export const fetchEmbassyMasterRequest = (payload) => {
  return {
    type: FETCH_EMBASSY_MASTER_REQUEST,
    payload,
  };
};

export const fetchEmbassyMasterSuccess = (payload) => {
  return {
    type: FETCH_EMBASSY_MASTER_SUCCESS,
    payload,
  };
};

export const fetchVilTemplateRequest = (payload) => {
  return {
    type: FETCH_VIL_TEMPLATE_REQUEST,
    payload,
  };
};

export const fetchVilTemplateSuccess = (payload) => {
  return {
    type: FETCH_VIL_TEMPLATE_SUCCESS,
    payload,
  };
};

export const fetchVilUpdateRequest = (payload) => {
  return {
    type: FETCH_VIL_UPDATE_REQUEST,
    payload,
  };
};

export const fetchVilUpdateSuccess = (payload) => {
  return {
    type: FETCH_VIL_UPDATE_SUCCESS,
    payload,
  };
};

export const fetchCountryRequest = () => {
  return {
    type: FETCH_COUNTRY_MASTER_REQUEST,
  };
};

export const fetchCountrySuccess = (payload) => {
  return {
    type: FETCH_COUNTRY_MASTER_SUCCESS,
    payload,
  };
};

export const fetchHealthConcernRequest = (payload) => {
  return {
    type: FETCH_HEALTHCONCERN_REQUEST,
    payload,
  };
};

export const fetchHealthConcernSuccess = (payload) => {
  return {
    type: FETCH_HEALTHCONCERN_SUCCESS,
    payload,
  };
};

export const fetchHospitalsRequest = (payload) => {
  return {
    type: FETCH_HOSPITALS_REQUEST,
    payload: payload,
  };
};

export const fetchHospitalsSuccess = (payload) => {
  return {
    type: FETCH_HOSPITALS_SUCCESS,
    payload,
  };
};

export const fetchExistingPatientsRequest = (payload) => {
  return {
    type: FETCH_EXISTING_PATIENTS_REQUEST,
    payload,
  };
};

export const fetchExistingPatientsSuccess = (payload) => {
  return {
    type: FETCH_EXISTING_PATIENTS_SUCCESS,
    payload,
  };
};

export const fetchDoctorReminderRequest = (payload) => {
  return {
    type: FETCH_DOCTOR_REMINDER_REQUEST,
    payload,
  };
};

export const fetchDoctorReminderSuccess = (payload) => {
  return {
    type: FETCH_DOCTOR_REMINDER_SUCCESS,
    payload,
  };
};

export const resetDoctorReminder = () => {
  return {
    type: RESET_DOCTOR_REMINDER,
  };
};
